import { OWN, SHIPPING, TUTULIST_LOWERCASE } from './constants';
import { getAuthorShippingPreference } from './dataExtractors';
import { ShippingOption } from './enums';
import { types as sdkTypes } from './sdkLoader';

const { Money } = sdkTypes;
const { FREE_SHIPPING } = ShippingOption;

const hasDeliveryOptions = deliveryOptions =>
  Array.isArray(deliveryOptions) && deliveryOptions.length > 0;

const includesDeliveryOption = (deliveryOptions, option) =>
  hasDeliveryOptions(deliveryOptions) && deliveryOptions.includes(option);

const toMinorUnitAmount = rawAmount => {
  if (typeof rawAmount === 'number' && Number.isFinite(rawAmount)) {
    return Math.trunc(rawAmount);
  }

  if (typeof rawAmount === 'string' && /^-?\d+$/.test(rawAmount.trim())) {
    return Number(rawAmount);
  }

  if (!rawAmount || typeof rawAmount !== 'object') {
    return null;
  }

  if (typeof rawAmount?.value !== 'undefined') {
    const nestedValue = toMinorUnitAmount(rawAmount.value);
    if (nestedValue !== null) {
      return nestedValue;
    }
  }

  if (typeof rawAmount?.toString === 'function') {
    const asString = rawAmount.toString();
    if (/^-?\d+$/.test(`${asString}`.trim())) {
      return Number(asString);
    }
  }

  if (Number.isFinite(rawAmount.low) && Number.isFinite(rawAmount.high)) {
    const low = rawAmount.low >>> 0;
    const high = rawAmount.high | 0;
    return high * 4294967296 + low;
  }

  return null;
};

export const getListingShippingInfo = ({ listing, price }) => {
  const publicData = listing?.attributes?.publicData || {};
  const deliveryOptions = publicData?.deliveryOptions;
  const amount = toMinorUnitAmount(publicData?.shippingPriceInSubunitsOneItem);
  const priceCurrency = price?.currency;

  const isFreeShippingDelivery = includesDeliveryOption(deliveryOptions, FREE_SHIPPING);
  const isTutulistDelivery = includesDeliveryOption(deliveryOptions, TUTULIST_LOWERCASE);
  const isExplicitOwnShipping =
    !isTutulistDelivery &&
    (includesDeliveryOption(deliveryOptions, SHIPPING) || isFreeShippingDelivery);
  const isLegacyOwnShipping =
    !hasDeliveryOptions(deliveryOptions) && getAuthorShippingPreference(listing?.author) === OWN;
  const isOwnShipping = isExplicitOwnShipping || isLegacyOwnShipping;

  if (!isOwnShipping) {
    return {
      isOwnShipping: false,
      isFreeShipping: false,
      shippingAmount: null,
      shippingLabelType: null,
    };
  }

  if (isFreeShippingDelivery || amount === 0) {
    return {
      isOwnShipping: true,
      isFreeShipping: true,
      shippingAmount: priceCurrency ? new Money(0, priceCurrency) : null,
      shippingLabelType: 'free',
    };
  }

  if (amount !== null && amount > 0 && typeof priceCurrency === 'string') {
    return {
      isOwnShipping: true,
      isFreeShipping: false,
      shippingAmount: new Money(amount, priceCurrency),
      shippingLabelType: 'amount',
    };
  }

  return {
    isOwnShipping: true,
    isFreeShipping: false,
    shippingAmount: null,
    shippingLabelType: null,
  };
};
